import React, { useEffect, useState } from 'react';
import {
  TabContent,
  sortStudentsAZ,
  StudentNavigation,
  SsaStudentProfileLoader,
  StudentProfileHeadingTypography,
} from '../ssaCommonUtils';
import {
  EmptyMessageBox,
  StudentProfileBox,
  SidebarCheckBoxIcon,
  StudentProfileTabCard,
} from '../ssaComponentStyled';
import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import Button from '@mui/material/Button';
import { useForm } from 'react-hook-form';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useSelector, useDispatch } from 'react-redux';
import BarChartIcon from '@mui/icons-material/BarChart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import {
  setSelectedSsaStudent,
  setSelectedStudentHeadingDetails,
} from '../../store/ssaStudentDetailSlice/ssaStudentDetailSlice';
import SsaProfileTab from './ssaProfileTabComponent/SsaProfileTab';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { ButtonGroupTab, ButtonGroupButton } from 'components/Ui/styled';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SsaAttendanceTab from './SsaAttendanceTabComponent/SsaAttendanceTab';
import SsaTestScoresTab from './ssaTestScoresTabComponent/SsaTestScoresTab';
import {
  addCompletedStudent,
  removeCompletedStudent,
} from '../../store/ssaSidenavBarStudentDetails/ssaSidenavBarStudentDetailsSlice';
import SsaStudentTrackersTab from './ssaStudentTrackersTabComponent/SsaStudentTrackersTab';
import { getSemesterDetails } from 'layouts/applications/attendance/services/attendanceApis';
import SsaAcademicProgressTab from './SsaAcademicProgressTabComponent/SsaAcademicProgressTab';
import CannedResponsesComponent from 'layouts/studentSuccessAdvocate/cannedResponses/components/CannedResponsesComponent';

const SsaStudentProfileTabs = () => {
  const dispatch = useDispatch();

  const studentList = useSelector(
    (state) => state.ssaStudentDetail.selectedStudentsList || [],
  );

  const activeStudentId = useSelector(
    (state) => state.ssaStudentDetail.selectedSsaStudent,
  );

  const nonCompliantOnly = useSelector(
    (state) => state?.ssaStudentDetail?.nonCompliantOnly || false,
  );

  const ssaStudentDetail = useSelector(
    (state) => state?.ssaStudentDetail?.selectedStudentHeadingDetails || {},
  );

  const sidebarStudents =
    useSelector(
      (state) => state?.ssaSidenavBarStudentDetails?.sideBarSelectedStudent,
    ) || [];

  const completedStudents = useSelector(
    (state) => state?.ssaSidenavBarStudentDetails?.completedStudents || [],
  );

  const filteredStudentList = sortStudentsAZ(
    nonCompliantOnly
      ? studentList?.filter((student) => {
          const sidebarStudent = sidebarStudents.find(
            (s) => s?.id === student?.studentId,
          );
          const completedStudent = completedStudents.find(
            (s) => s?.id === student?.studentId,
          );
          const foundStudent = sidebarStudent || completedStudent;
          return foundStudent && !foundStudent?.inCompliance;
        })
      : studentList,
  );

  const currentIndex = filteredStudentList.findIndex(
    (s) => s.studentId === activeStudentId,
  );

  const currentStudent = sidebarStudents.find((s) => s.id === activeStudentId);

  const isStudentReady =
    Boolean(activeStudentId) && Boolean(ssaStudentDetail?.studentId);

  useEffect(() => {
    if (currentStudent?.apiError) {
      setHasChildError(true);
      // setChildErrorMessage('');
    } else {
      setSelected('attendance');
      setHasChildError(false);
      setChildErrorMessage('');
    }
  }, [currentStudent?.apiError, activeStudentId]);

  const sortedSelectedStudents = React.useMemo(
    () => sortStudentsAZ(studentList),
    [studentList],
  );

  const firstAlphabeticalStudent = sortedSelectedStudents[0];

  const headerStudent =
    sidebarStudents.find((s) => s.id === activeStudentId) ||
    completedStudents.find((s) => s.id === activeStudentId) ||
    sortedSelectedStudents.find((s) => s.studentId === activeStudentId) ||
    firstAlphabeticalStudent ||
    {};

  const { grade, firstName, lastName, studentId } = headerStudent || {};

  const [hasChildError, setHasChildError] = useState(false);
  const [currentSemester, setCurrentSemester] = useState([]);
  const [childErrorMessage, setChildErrorMessage] = useState('');

  const getCurrentSemester = async () => {
    const semesters = await getSemesterDetails();
    setCurrentSemester(semesters[0]);
  };

  useEffect(() => {
    getCurrentSemester();
  }, []);

  const tabs = [
    {
      key: 'attendance',
      label: 'Attendance',
      component: (
        <SsaAttendanceTab
          onError={setHasChildError}
          onErrorMessage={setChildErrorMessage}
        />
      ),
      icon: <EventAvailableIcon fontSize="small" />,
    },
    {
      key: 'academic progress',
      label: 'Academic Progress',
      component: <SsaAcademicProgressTab />,
      icon: <BarChartIcon fontSize="small" />,
    },
    {
      key: 'profile',
      label: 'Profile',
      component: <SsaProfileTab />,
      icon: <PersonIcon fontSize="small" />,
    },
    {
      key: 'test scores',
      label: 'Test Scores',
      component: <SsaTestScoresTab />,
      icon: <ShowChartIcon fontSize="small" />,
    },
    {
      key: 'student trackers',
      label: 'Student Trackers',
      component: <SsaStudentTrackersTab currentSemester={currentSemester} />,
      icon: <ListAltIcon fontSize="small" />,
    },
    {
      key: 'canned responses',
      label: 'Canned Responses',
      component: <CannedResponsesComponent />,
      icon: <ChatBubbleOutlineIcon fontSize="small" />,
    },
  ];

  const [selected, setSelected] = useState(tabs[0].key);

  // const gradeHeading = `Grade: ${grade}`;
  // const studentHeading = `${lastName}, ${firstName} : ${studentId}`;

  const studentHeading =
    headerStudent?.lastName && headerStudent?.firstName
      ? `${headerStudent?.lastName}, ${headerStudent.firstName} : ${
          headerStudent?.studentId || headerStudent.id
        }`
      : '';

  const gradeHeading = headerStudent?.grade
    ? `Grade: ${headerStudent.grade}`
    : '';

  const isPrevDisabled = currentIndex <= 0;
  const isNextDisabled = currentIndex >= filteredStudentList.length - 1;

  const totalCount = filteredStudentList.length;
  // const displayIndex = currentIndex + 1;
  const displayIndex =
    currentIndex >= 0
      ? currentIndex + 1
      : filteredStudentList.length > 0
        ? 1
        : 0;

  const normalizeStudent = (s) => ({
    studentId: s?.studentId || s?.id,
    grade: s?.grade,
    lastName: s?.lastName,
    firstName: s?.firstName,
    semester: currentSemester,
  });

  const goPrev = () => {
    if (currentIndex > 0) {
      const prevStudent = filteredStudentList[currentIndex - 1];

      dispatch(setSelectedSsaStudent(prevStudent.studentId));
      dispatch(setSelectedStudentHeadingDetails(normalizeStudent(prevStudent)));
      setSelected(tabs[0].key);
      setHasChildError(false);
    }
  };

  const goNext = () => {
    if (currentIndex < filteredStudentList.length - 1) {
      const nextStudent = filteredStudentList[currentIndex + 1];

      dispatch(setSelectedSsaStudent(nextStudent.studentId));
      dispatch(setSelectedStudentHeadingDetails(nextStudent));
      setSelected(tabs[0].key);
      setHasChildError(false);
    }
  };

  const { control, watch, reset } = useForm({
    defaultValues: {
      autoAdvance: true,
    },
  });

  const autoAdvancewatch = watch('autoAdvance');

  useEffect(() => {
    reset({
      autoAdvance: true,
    });
  }, [reset]);

  const isCompleted = completedStudents?.some(
    (s) => s?.id === (headerStudent?.id || headerStudent?.studentId),
  );

  const normalizedStudent = {
    id: headerStudent?.id || headerStudent?.studentId,
    firstName: headerStudent?.firstName,
    lastName: headerStudent?.lastName,
    grade: headerStudent?.grade,
    apiError: headerStudent?.apiError,
    inCompliance: headerStudent?.inCompliance,
    semester: currentSemester,
  };

  const handleMarkCompleteIncomplete = () => {
    if (!normalizedStudent.id) return;

    if (isCompleted) {
      dispatch(removeCompletedStudent(normalizedStudent));
    } else {
      dispatch(addCompletedStudent(normalizedStudent));

      if (autoAdvancewatch) {
        goNext();
      }
    }
  };

  const hasMultipleStudents = studentList?.length > 1;
  const endIcon = isCompleted ? '⏳' : <SidebarCheckBoxIcon isactive="true" />;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <StudentProfileTabCard>
          <StudentProfileBox>
            <StudentProfileHeadingTypography heading={studentHeading} />
            <StudentProfileHeadingTypography heading={gradeHeading} />
            {hasMultipleStudents && (
              <>
                <Button
                  endIcon={endIcon}
                  variant="outlined"
                  onClick={handleMarkCompleteIncomplete}
                >
                  {isCompleted ? 'Mark Incomplete' : 'Mark Complete'}
                </Button>

                <Box>
                  <FormInputSwitch
                    control={control}
                    name="autoAdvance"
                    label="Auto-advance"
                  />
                </Box>
                <StudentNavigation
                  goPrev={goPrev}
                  goNext={goNext}
                  totalCount={totalCount}
                  displayIndex={displayIndex}
                  isPrevDisabled={isPrevDisabled}
                  isNextDisabled={isNextDisabled}
                />
              </>
            )}
          </StudentProfileBox>
          {!isStudentReady && <SsaStudentProfileLoader />}

          {isStudentReady && !hasChildError && (
            <Box display="flex" justifyContent="left" mt={2} mb={3} ml={4}>
              <ButtonGroupTab disableElevation>
                {tabs?.map((tab) => (
                  <ButtonGroupButton
                    key={tab.key}
                    disableRipple
                    onClick={() => setSelected(tab.key)}
                    sx={{
                      px: 4,
                      py: 1.5,

                      // Selected state
                      ...(selected === tab.key && {
                        border: '1px solid #0066cc !important',
                        backgroundColor: 'rgba(0, 102, 204, 0.1)',
                        color: '#0066cc',
                      }),

                      // Hover state for all buttons
                      '&:hover': {
                        color: '#0066cc',
                        borderColor: '#0066cc',
                        backgroundColor:
                          selected === tab.key
                            ? 'rgba(0, 102, 204, 0.1)'
                            : 'transparent',

                        // Apply border on hover for all buttons
                        border: '1px solid #0066cc !important',
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {tab.icon}
                      {tab.label}
                    </Box>
                  </ButtonGroupButton>
                ))}
              </ButtonGroupTab>
            </Box>
          )}

          {!isStudentReady ? null : hasChildError ? (
            <EmptyMessageBox>{childErrorMessage}</EmptyMessageBox>
          ) : (
            <TabContent tabs={tabs} selected={selected} />
          )}
        </StudentProfileTabCard>
      </MDBox>
    </DashboardLayout>
  );
};

export default SsaStudentProfileTabs;
